import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { useEffect } from 'react';

const ColorPicker = ({
  color = {
    hex: '#333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
  },
  onChange,
  text,
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = color => {
    onChange(color);
  };
  useEffect(() => {
    if (color == null) {
      color = {
        hex: '#333',
        rgb: {
          r: 51,
          g: 51,
          b: 51,
          a: 1,
        },
      };
    }
  }, [color]);
  return (
    <div>
      <div
        style={{
          padding: '2px',
          background: 'transparent',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'flex',
          flexDirection: 'row',
          gap: '5px',
          alignContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <div
          style={{
            width: '16px',
            height: '14px',
            borderRadius: '2px',
            background: `rgba(${color?.rgb.r}, ${color?.rgb.g}, ${color?.rgb.b}, ${color?.rgb.a})`,
          }}
        />
        <p style={{ color: 'white', fontWeight: 600, fontSize: '22px' }}>
          {text}
        </p>
      </div>
      {displayColorPicker ? (
        <div style={{ position: 'absolute', zIndex: '2' }}>
          <div
            style={{
              position: 'fixed',
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px',
            }}
            onClick={handleClose}
          />
          <SketchPicker
            color={color?.rgb}
            onChange={handleChange}
            styles={{controls:{color:'black'}}}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
